const resolveNewsGalleryUrl = (entry) => {
  if (!entry) return '';
  if (typeof entry === 'string') return entry;
  return entry.original || entry.url || entry.src || '';
};

const stripHtmlForFingerprint = (value) => {
  const raw = (value || '').toString();
  return raw
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const normalizeNewsFingerprintPart = (value = '') =>
  stripHtmlForFingerprint(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR')
    .replace(/\s+/g, ' ')
    .trim();

const buildNewsEditorialFingerprint = (item) => {
  const primaryMediaUrl =
    item?.image ||
    (Array.isArray(item?.gallery) && item.gallery.length ? resolveNewsGalleryUrl(item.gallery[0]) : '');
  const summary = item?.subtitle || item?.content || '';

  return [
    normalizeNewsFingerprintPart(item?.title),
    normalizeNewsFingerprintPart(primaryMediaUrl),
    normalizeNewsFingerprintPart(summary)
  ].join('|');
};

export const dedupeNewsByEditorialContent = (items = []) => {
  const seen = new Set();

  return (items || []).filter((item) => {
    const fingerprint = buildNewsEditorialFingerprint(item);
    if (!fingerprint || fingerprint === '||') return true;
    if (seen.has(fingerprint)) return false;
    seen.add(fingerprint);
    return true;
  });
};